import { Copy, Trash2, X } from 'lucide-react';
import DayCard from "./DayCard";
import { useContext, useEffect, useState } from 'react';
import { ProgramContext } from '../../context/ProgramsContext';

const WeekComponent = ({ week, ...props }) => {
    const { isPast, setPlan, initialPlan } = useContext(ProgramContext);
    const isWeekInPastWithTasks = week.days.some(day => {
        const dayIsPast = isPast(day.date);

        const hasImportantActivity = day.activities.some(
            (a) => a.is_complete || a.is_skipped || a.is_incomplete
        );

        const isPastAndWasInInitialWeeks = week.days.every(d => isPast(d.date)) && initialPlan?.weeks?.some((w) => {
            const dayContainsActivities = w?.days.some(d => d.activities.length > 0)
            return w?.id === week?.id && !dayContainsActivities
        })
        return ((dayIsPast || hasImportantActivity) && (day.activities.length > 0)) || isPastAndWasInInitialWeeks;
    });

    if (isWeekInPastWithTasks) {
        localStorage.setItem("maxDisabledWeek", week.weekNumber)
    }

    const [draggedActivity, setDraggedActivity] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleDeleteClick = () => {
        setShowConfirmModal(true);
    };

    const confirmDelete = () => {
        setShowConfirmModal(false);
        props.onDeleteWeek(week.id);
    };

    const reorderActivityWithinDay = (dayId, sourceId, targetId) => {
        setPlan(prev => {
            const newPlan = JSON.parse(JSON.stringify(prev));
            for (const week of newPlan.weeks) {
                for (const day of week.days) {
                    if (day.id === dayId) {
                        const oldIndex = day.activities.findIndex(a => a.id === sourceId);
                        const newIndex = day.activities.findIndex(a => a.id === targetId);
                        if (oldIndex > -1 && newIndex > -1) {
                            const [moved] = day.activities.splice(oldIndex, 1);
                            day.activities.splice(newIndex, 0, moved);
                        }
                    }
                }
            }
            return newPlan;
        });
    };


    return (
        <div
            draggable={false}
            // onDragStart={(e) => props.onDragStart(e, week, 'week')}
            // onDrop={(e) => props.onDrop(e, { dropZone: 'week', weekId: week.id })}
            // onDragOver={(e) => e.preventDefault()}
            className={`mb-6 p-4 bg-white rounded-2xl shadow-md transition-all overflow-hidden`}
        >
            {/* Week Header */}
            <div className="flex flex-wrap justify-between items-center gap-2 mb-4">
                <h3 className="text-xl font-bold text-gray-800">Week {week.weekNumber}</h3>

                <div className="flex items-center space-x-1">
                    <button
                        onClick={() => props.onCopyWeek(week.id)}
                        className="p-2 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition"
                    >
                        <Copy size={18} />
                    </button>

                    <button
                        onClick={handleDeleteClick}
                        disabled={isWeekInPastWithTasks}
                        className="p-2 rounded-md text-red-500 hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed transition"
                    >
                        <Trash2 size={18} />
                    </button>
                </div>
            </div>

            {/* Days Scrollable Container */}
            <div className="flex space-x-3 overflow-x-auto pb-3">
                {week.days.map((day) => (
                    <DayCard key={day.id} day={day} {...props} draggedActivity={draggedActivity} setDraggedActivity={setDraggedActivity} reorderActivityWithinDay={reorderActivityWithinDay} />
                ))}
            </div>

            {/* Confirm Delete Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[60] animate-fade-in-up">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[95vw] sm:max-w-md p-6 transform transition-all flex flex-col max-h-[90vh]">

                        {/* Header */}
                        <div className="flex justify-between items-center mb-4 border-b pb-4">
                            <h2 className="text-xl font-bold text-gray-800">Delete Week {week.weekNumber}</h2>
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="p-2 rounded-full hover:bg-gray-200 transition"
                            >
                                <X size={22} className="text-gray-500" />
                            </button>
                        </div>

                        {/* Body Text */}
                        <div className="text-gray-700 mb-6 text-sm">
                            Are you sure you want to delete this week? This will remove all days in this week and cannot be undone.
                        </div>

                        {/* Footer Buttons */}
                        <div className="flex justify-end gap-3 pt-2 border-t">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={confirmDelete}
                                className="px-4 py-2 rounded-lg bg-red-500 text-white font-semibold hover:bg-red-600 transition"
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WeekComponent;
